/**
 * キャスト週まとめ登録の差分算出（純粋関数）。
 * ダイアログの7日分の入力状態から、実行すべき 作成/更新/却下 を導出する。
 * 指名予約ロック日はいかなる操作も生成しない（サーバ側でも検証されるが二重に守る）
 *
 * row: {
 *   date: 'yyyy-MM-dd',
 *   checked: boolean,
 *   locked: boolean,
 *   startTime: 'HH:mm' | '',
 *   endTime: 'HH:mm' | '',
 *   existing: { id, startTime: 'HH:mm'|'', endTime: 'HH:mm'|'' } | null,
 * }
 */
export const buildCastWeekOps = rows => {
  const normalize = value => value || ''

  const invalid = (rows || []).find(row => {
    if (row.locked || !row.checked) return false

    return (normalize(row.startTime) === '') !== (normalize(row.endTime) === '')
  })
  if (invalid) {
    return { ok: false, error: `${invalid.date} は出勤と退勤をセットで入力してください` }
  }

  const creates = []
  const updates = []
  const rejects = [];
  (rows || []).forEach(row => {
    if (row.locked) return

    const start = normalize(row.startTime)
    const end = normalize(row.endTime)

    if (row.checked && !row.existing) {
      creates.push({ date: row.date, startTime: start, endTime: end })

      return
    }

    if (row.checked && row.existing) {
      const changed = start !== normalize(row.existing.startTime) || end !== normalize(row.existing.endTime)
      if (changed) {
        updates.push({
          id: row.existing.id, date: row.date, startTime: start, endTime: end,
        })
      }

      return
    }

    if (!row.checked && row.existing) {
      rejects.push(row.existing.id)
    }
  })

  return {
    ok: true, creates, updates, rejects,
  }
}
